import { images } from '../constants';

const team = [
    {
        id: 1,
        Image: images.team1,
        name: 'Aguas del Valle'
    },
    {
        id: 2,
        Image: images.team2,
        name: 'MOP Ministerio de Obras Públicas',
        title: 'Assistant Manager',
    },
    {
        id: 3,
        Image: images.team3,
        name: 'Fiscalía Regional',
        title: 'Director',
    },
    {
        id: 4,
        Image: images.team4,
        name: 'Ministerio Público',
        title: 'Technician',
    },
    {
        id: 5,
        Image: images.team5,
        name: 'Ecomac',
    },
    {
        id: 6,
        Image: images.team6,
        name: 'Constructora Elqui',
    },
    {
        id: 7,
        Image: images.team7,
        name: 'Inmobiliaria Habita',
    }
];


export default team;